exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-content[data-v-7540be2f]{display:inline-block;margin-right:10px;font-size:14px;color:#333}.title-content .title[data-v-7540be2f]{font-weight:bold}.title-content .title[data-v-7540be2f]:after{content:\": \"}", ""]);

// exports
